import { useWorkspaceText } from '../interface-copy';
import { useState } from 'react';
import { ConfirmDialog } from '@/components/ui/confirm-dialog';
import { formatCopy, useNamespaceCopy } from '@/i18n/ns';
import { overlaysCopy } from '@/i18n/ns/overlays';
import workspaceFeedbackCopy from '@/i18n/ns/workspace-feedback';
import { agentsApi, type Agent } from './api';
import { CLOSES_CANVAS, type Act } from './shared';

/** The canvas must ask before archiving, just like the Agents list. */
export function ArchiveAction({
  agent,
  busy,
  act,
}: {
  agent: Pick<Agent, 'id' | 'name'>;
  busy: boolean;
  act: Act;
}) {
  const { text: uiText, rich: uiRich } = useWorkspaceText();
  const [confirming, setConfirming] = useState(false);
  const copy = useNamespaceCopy(overlaysCopy);
  const feedback = useNamespaceCopy(workspaceFeedbackCopy);
  const archive = async () => {
    await act(
      async () => {
        await agentsApi.archive(agent.id);
        return CLOSES_CANVAS;
      },
      formatCopy(feedback.agentArchived, { name: agent.name }),
    );
    setConfirming(false);
  };
  return (
    <>
      <p className="ws-agents-section-title">{uiText('Archive')}</p>
      <button className="ws-text-button" disabled={busy} onClick={() => setConfirming(true)}>
        {uiText('Archive this agent')}
      </button>
      {confirming && (
        <ConfirmDialog
          title={copy.archiveTitle}
          description={formatCopy(copy.archiveDescription, { name: agent.name })}
          confirmLabel={formatCopy(copy.archiveConfirm, { name: agent.name })}
          busy={busy}
          onCancel={() => setConfirming(false)}
          onConfirm={() => void archive()}
        />
      )}
    </>
  );
}
